import React from 'react'
import Backdrop from '@mui/material/Backdrop';
export default function Modal({ children, state, setState }) {
    const handleClose = () => { setState(false); };
    return (
        <div>
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: 900})} open={state} onClick={() => handleClose()}>
                {children}
            </Backdrop>
        </div>
    )
}
